import { ValidationError } from '@tanstack/react-form'
import { ReactNode } from '@tanstack/react-router'
import { useId } from 'react'
import { validationErrorMessages } from '../validation-error-message'

export type WidgetInputTextFieldProps = {
	id?: string
	value: string
	onChange: (value: string) => void
	placeholder?: string
	hint?: ReactNode
	errors?: Array<ValidationError>
}

export function WidgetInputTextField(
	{ id: externalId, value, onChange, hint, placeholder, errors }: WidgetInputTextFieldProps,
) {
	const generatedId = useId()
	const id = externalId ?? generatedId

	return (
		<div className="grid gap-2 text-left">
			<input
				className="w-full rounded-md border border-grey-300 bg-white px-2.5 py-1.5 text-sm outline-none transition-[border-color,box-shadow] duration-150 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/15"
				type="text"
				value={value}
				onChange={(e) => onChange(e.target.value)}
				id={id}
				placeholder={placeholder}
			/>
			{hint && <div className="text-xs text-grey-500">{hint}</div>}
			{validationErrorMessages(errors).map((message, index) => (
				<div className="text-red-500 text-xs" key={index}>{message}</div>
			))}
		</div>
	)
}
